import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 4.375H8.33687L6.71187 2.54438C6.59422 2.41207 6.44981 2.30626 6.28818 2.23396C6.12656 2.16166 5.95143 2.12453 5.77437 2.125H2.5C2.16848 2.125 1.85054 2.2567 1.61612 2.49112C1.3817 2.72554 1.25 3.04348 1.25 3.375V12.6638C1.2505 12.9848 1.37827 13.2926 1.60531 13.5197C1.83236 13.7467 2.14016 13.8745 2.46125 13.875H13.5556C13.8723 13.8747 14.1759 13.7487 14.3998 13.5248C14.6237 13.3009 14.7497 12.9973 14.75 12.6806V5.625C14.75 5.29348 14.6183 4.97554 14.3839 4.74112C14.1495 4.5067 13.8315 4.375 13.5 4.375ZM2.75 3.625H5.66313L6.33 4.375H2.75V3.625ZM13.25 12.375H2.75V5.875H13.25V12.375Z",
		fill: "#141515"
	})
});
export default SvgFolder;
